import { render, staticRenderFns } from "./ResolutionZone.vue?vue&type=template&id=339219b8"
import script from "./ResolutionZone.vue?vue&type=script&lang=js"
export * from "./ResolutionZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports